<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm1 v-if="displayClientForm">
      <v-text-field v-model="clientName" label="Naam klant" required></v-text-field>
      <v-list>
        <v-list-tile v-for="client in clients" v-bind:key="client.id" class="listitem" @click="openClient(client)">
          <v-list-tile-content>{{ client.name }}</v-list-tile-content>
<!--          <v-list-tile-action>-->
<!--            <v-btn icon flat color="primary" @click="remove(client.id)">-->
<!--              <v-icon class="pa-2">delete_forever</v-icon>-->
<!--            </v-btn>-->
<!--          </v-list-tile-action>-->
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-flex xs12 sm6 offset-sm1 v-if="!displayClientForm">
      <v-text-field v-model="clientArea" label="Wijk" required></v-text-field>
      <v-list>
        <v-list-tile v-for="area in selectedClient.areas" v-bind:key="area" class="listitem">
          <v-list-tile-content>{{ area }}</v-list-tile-content>
<!--          <v-list-tile-action>-->
<!--            <v-btn icon flat color="primary" @click="removeArea(area)">-->
<!--              <v-icon class="pa-2">delete_forever</v-icon>-->
<!--            </v-btn>-->
<!--          </v-list-tile-action>-->
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-flex>
      <v-btn @click="submit" color="primary" :disabled="nameIsNotLongEnough(clientName)" v-if="displayClientForm">Opslaan</v-btn>
      <v-btn @click="submitArea" color="primary" :disabled="nameIsNotLongEnough(clientArea)" v-if="!displayClientForm">Opslaan</v-btn>
      <v-btn @click="closeClient" color="primary" v-if="!displayClientForm">Sluiten</v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "client-add-form",
  data: () => ({
    clientName: null,
    displayClientForm: true,
    selectedClient: null,
    clientArea: null,
  }),
  computed: {
    ...mapGetters({
      clients: "clientList",
    }),
  },
  methods: {
    ...mapActions([
      "saveClient",
      "deleteClient",
      "loadClients",
      "changeClient"
    ]),
    nameIsNotLongEnough(name) {
      if (name) {
        return name < 2;
      }
      return true;
    },
    remove(id) {
      this.deleteClient(id);
    },
    submit() {
      this.saveClient({"client": this.clientName});
      this.clear();
    },
    openClient(client) {
      this.selectedClient = client;
      this.displayClientForm = false;
    },
    removeArea(area) {
      let payload = {
        "id": this.selectedClient.id,
        "clientName": this.selectedClient.name,
        "areas": this.selectedClient.areas.filter(a => a !== area)
      }
      this.changeClient(payload);
    },
    submitArea() {
      // this.selectedClient.areas.push(this.clientArea); // TODO: adding a client area must be done in VUEX
      let payload = {
        "id": this.selectedClient.id,
        "clientName": this.selectedClient.name,
        "areas": [this.clientArea].concat(this.selectedClient.areas)
      }
      this.changeClient(payload);
      this.clear();
    },
    closeClient() {
      this.displayClientForm = true;
      this.selectedClient = null;
      this.clientName = null;
      this.clientArea = null;
    },
    clear() {
      this.clientArea = null;
      this.clientName = null;
    }
  },
  created() {
    this.loadClients();
  }
};
</script>